// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"81":"245d9b1c","221":"5eec189e","265":"f71b724d","288":"7ea9b06a","353":"a3df6178","367":"8fd447b0","507":"ae2b528e","523":"4029230a","561":"eeaebd1e","675":"f8134134","748":"47bd78f8","749":"5b5b8e3a","785":"0f3fa6e4","870":"0a26d784","968":"97388f7e"}[chunkId] + ".chunk.js";
};